<form *ngIf="modificationForm" [formGroup]="modificationForm">
  <div class="row">

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="reasonModificationId">Motivo de modificación <span class="required">*</span></label>
        <select class="form-select" id="reasonModificationId" aria-label="Default select example"
                formControlName="reasonModificationId"
                [ngClass]="{'error': isTouchedField(modificationForm, 'reasonModificationId')}">
          <option value="" selected disabled>Seleccione</option>
          <option *ngFor="let reason of reasonsModification" [value]="reason.id">{{reason.description}}</option>
        </select>
        <span *ngIf="!isValidField(modificationForm, 'reasonModificationId')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="reason-note" role="alert"
              aria-live="assertive">
                  {{ getErrorMessage('reasonModificationId') }}
          </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <label for="inptFileLicVigenteAria" class="label-carga-de-archivo-govco">Licencia Vigente a modificar
        <span class="required">*</span></label>
      <div class="input-group mt-2 mb-1">
        <input type="file" class="form-control input-file-custom" id="inptFileLicVigenteAria"
               aria-describedby="inptFileLicVigenteAria" aria-label="Upload"
               formControlName="file"
               accept="application/pdf"
               (change)="verificarArchivoEscogido($event)">
     </div>
      <span class="text-validation-carga-de-archivo-govco"><small>Únicamente archivo(s) en formato .pdf</small></span>
      <span *ngIf="!isValidField(modificationForm, 'resolutionToModify')"
            class="error-texto-govco alert-entradas-de-texto-govco" id="file-note" role="alert"
            aria-live="assertive">
          {{ getErrorMessage('licenciaVigenteFile') }}
        </span>

    </div>

    <div class="col-sm-12 col-md-6" *ngIf="isPersonaJuridica==true">
      <label for="inptFileSoporteModificacion" class="label-carga-de-archivo-govco"> PDF Soporte de la modificación
        <span class="required">*</span></label>
      <button type="button" class="btn-govco fill-btn-govco"
              style="margin-right: 10px"
              (click)="popUpAyudaSoporteModificacion()">Ayuda</button>
      <div class="input-group mt-2 mb-1">
        <input type="file" class="form-control input-file-custom" id="inptFileSoporteModificacion"
               aria-describedby="inptFileSoporteModificacion" aria-label="Upload"
               formControlName="fileSoporte"
               accept="application/pdf" (change)="verificarArchivoEscogidoSoporteModificacion($event)">

      </div>
      <span class="text-validation-carga-de-archivo-govco"><small>Únicamente archivo(s) en formato .pdf</small></span>
      <br>
    </div>


    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="numberResolution-id">Número de resolución vigente a la cual se le va a realizar la
          modificación <span class="required">*</span></label>
        <input type="text" id="numberResolution-id" placeholder="Número de resolución"
               formControlName="resolutionToModify"
               [ngClass]="{'error': isTouchedField(modificationForm, 'resolutionToModify')}"
        />
        <span *ngIf="!isValidField(modificationForm, 'resolutionToModify')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="number-note" role="alert"
              aria-live="assertive">
                  {{ getErrorMessage('resolutionToModify') }}
          </span>
      </div>
    </div>


    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="fecha-resolucion-licencia-vigente">Fecha de resolución vigente a la cual se le va a realizar la
          modificación <span aria-required="true">*</span> </label>
        <input type="date" id="fecha-resolucion-licencia-vigente"
               placeholder="Fecha de resolución de la licencia vigente"
               formControlName="dateResolutionToModify"
               (click)="verificarFecha()"
               [ngClass]="{'error': isTouchedField(modificationForm, 'dateResolutionToModify') }"
        />
        <span *ngIf="!isValidField(modificationForm, 'dateResolutionToModify')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="fecha-resolucion-vigente-note" role="alert"
              aria-live="assertive">
          {{ getErrorMessage('dateResolutionToModify') }}
        </span>
      </div>
    </div>
  </div>
</form>

